import * as Yup from 'yup'

const scheduleStatusValidator = Yup.object ({
  name: Yup
    .string ()
    .required ('Insira o nome'),

  color: Yup
    .string ()
    .required ('Insira a cor')
})

export default scheduleStatusValidator
